// Static site config for Family HealthCare Hospital
export const HOSPITAL = {
  name: "Family HealthCare",
  tagline: "Compassionate care, close to home",
  phone: "+91 96508 13125",
  phoneDial: "+919650813125",
  whatsapp: "919650813125",
  email: "info@familyhealthcarehospital.com",
  address: "Main Market, Railway Station Rd, New Colony, Garhi Harsaru, Gurugram, Haryana 122505",
  shortAddress: "Garhi Harsaru, Gurugram",
  hoursLabel: "24x7 Emergency • OPD 8am – 9pm",
  logo: "https://familyhealthcarehospital.com/logo.png",
  mapEmbed:
    "https://www.google.com/maps?q=Garhi+Harsaru+Gurugram+Haryana+122505&output=embed",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Doctors", to: "/doctors" },
  { label: "Services", to: "/services" },
  { label: "Departments", to: "/departments" },
  { label: "Facilities", to: "/facilities" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const FACILITIES = [
  {
    key: "pathology",
    title: "Pathology Lab",
    icon: "FlaskConical",
    image: "https://images.pexels.com/photos/8442027/pexels-photo-8442027.jpeg",
    summary:
      "NABL-style sample collection with quick turnaround on routine and specialised tests — CBC, biochemistry, hormones, cultures and more.",
  },
  {
    key: "radiology",
    title: "Radiology Centre",
    icon: "ScanLine",
    image:
      "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=80",
    summary:
      "Digital X-ray, ultrasound and colour Doppler with same-day reports interpreted by experienced radiologists.",
  },
  {
    key: "icu",
    title: "Intensive Care Unit",
    icon: "HeartPulse",
    image:
      "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=80",
    summary:
      "Multi-bedded ICU with multipara monitors, ventilators, syringe pumps and round-the-clock intensivist supervision.",
  },
  {
    key: "ot",
    title: "Advanced OT",
    icon: "Stethoscope",
    image:
      "https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200&q=80",
    summary:
      "Modular operation theatres with HEPA-filtered air, anaesthesia workstations and laparoscopic equipment for safer surgery.",
  },
  {
    key: "er",
    title: "24x7 Emergency",
    icon: "Siren",
    image:
      "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?w=1200&q=80",
    summary:
      "Casualty and trauma care available every hour of every day — staffed by trained ER doctors and rapid-response nurses.",
  },
  {
    key: "pharmacy",
    title: "Modern Pharmacy",
    icon: "Pill",
    image: "https://images.pexels.com/photos/19471013/pexels-photo-19471013.jpeg",
    summary:
      "In-house pharmacy stocked with branded and generic medicines, surgical supplies and emergency drugs at honest prices.",
  },
  {
    key: "opd",
    title: "Expert OPD",
    icon: "UserRound",
    image:
      "https://images.unsplash.com/photo-1758691462482-2b6ccbaefa6e?w=1200&q=80",
    summary:
      "Daily OPDs across General Medicine, Gynecology, Pediatrics, Skin, Surgery and Orthopedics — minimal waiting times.",
  },
  {
    key: "ipd",
    title: "Affordable IPD",
    icon: "BedDouble",
    image:
      "https://images.unsplash.com/photo-1719934398679-d764c1410770?w=1200&q=80",
    summary:
      "General, semi-private and private rooms with attendant facility, daily doctor rounds and transparent billing.",
  },
  {
    key: "nursing",
    title: "Best Nursing Staff",
    icon: "HandHeart",
    image:
      "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=1200&q=80",
    summary:
      "Trained, GNM/B.Sc qualified nurses delivering attentive, kind and skilled care to every admitted patient.",
  },
];

export const DEPARTMENTS = [
  {
    key: "general-medicine",
    name: "General Medicine",
    icon: "Stethoscope",
    description:
      "Diagnosis and treatment of fevers, infections, diabetes, hypertension, thyroid, and other adult illnesses.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80",
  },
  {
    key: "gynecology",
    name: "Gynecology & Obstetrics",
    icon: "Baby",
    description:
      "Antenatal care, normal & C-section deliveries, infertility evaluation, PCOS, menstrual and menopausal care.",
    image: "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?w=1200&q=80",
  },
  {
    key: "pediatrics",
    name: "Pediatrics",
    icon: "Baby",
    description:
      "Newborn and child care including immunization, growth monitoring, fevers, asthma and pediatric emergencies.",
    image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=1200&q=80",
  },
  {
    key: "general-surgery",
    name: "General Surgery",
    icon: "Scissors",
    description:
      "Hernia, gallbladder, appendix, piles/fissure, lumps and minor day-care surgeries — laparoscopic and open.",
    image: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200&q=80",
  },
  {
    key: "orthopedics",
    name: "Orthopedics",
    icon: "Bone",
    description:
      "Fracture care, joint pain, sports injuries, slipped disc, joint replacement and arthroscopic surgery.",
    image: "https://images.unsplash.com/photo-1666214280557-f1b5022eb634?w=1200&q=80",
  },
  {
    key: "dermatology",
    name: "Dermatology",
    icon: "Sparkles",
    description:
      "Acne, pigmentation, allergies, hair loss, fungal and skin infections — medical & cosmetic dermatology.",
    image: "https://images.unsplash.com/photo-1631217872822-1c2546d6b864?w=1200&q=80",
  },
];

export const TPA_PARTNERS = [
  { name: "Volo Health" },
  { name: "Medi Assist" },
  { name: "FHPL" },
  { name: "HDFC ERGO" },
  { name: "ICICI Lombard" },
];

export const SERVICES = [
  {
    key: "tpa",
    title: "TPA & Cashless Insurance",
    summary:
      "We are empaneled with leading TPAs to make hospitalization cashless and stress-free.",
    icon: "ShieldCheck",
  },
  {
    key: "health-checkups",
    title: "Health Check-up Packages",
    summary:
      "Affordable preventive packages — Basic, Comprehensive, Diabetes, Cardiac and Women's Wellness.",
    icon: "ClipboardCheck",
  },
  {
    key: "ambulance",
    title: "Ambulance Service",
    summary:
      "Equipped ambulance available on-call for transfers and emergencies in and around Garhi Harsaru.",
    icon: "Ambulance",
  },
  {
    key: "vaccination",
    title: "Vaccination Clinic",
    summary:
      "Routine and travel vaccinations for infants, children and adults as per the latest IAP/IMA schedule.",
    icon: "Syringe",
  },
  {
    key: "daycare",
    title: "Day-care Procedures",
    summary:
      "Minor surgeries, dressings, IV therapy and procedures completed within a few hours — no overnight stay.",
    icon: "Activity",
  },
  {
    key: "diet",
    title: "Diet & Nutrition",
    summary:
      "Personalised diet plans for diabetes, pregnancy, weight management and post-surgery recovery.",
    icon: "Salad",
  },
];

export const VALUES = [
  { title: "Patient first", text: "Every clinical and operational decision begins with what's right for the patient." },
  { title: "Honest pricing", text: "Transparent estimates upfront — no surprise bills, no hidden charges." },
  { title: "Local & accessible", text: "A trusted neighbourhood hospital for the families of Garhi Harsaru and around." },
  { title: "Skilled team", text: "Experienced doctors, GNM/B.Sc nurses and trained paramedics — together." },
];
